import { Component } from '@angular/core';

@Component({
  selector: 'app-planilla-liquidaciones',
  templateUrl: './planilla-liquidaciones.component.html',
  styleUrls: ['./planilla-liquidaciones.component.scss']
})
export class PlanillaLiquidacionesComponent   {


 

}
